module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "header__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('img', {
    staticClass: "header__logo",
    attrs: {
      "src": require("../assets/img/logos.png"),
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52186acf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 568
// module chunks = 1